export default __webpack_public_path__ + "static/media/banner7.0fcfc765.png";